import _ from 'lodash'
import { useState } from 'react'

const useForm = (initalState, formName) => {
  const [formValue, setFormValue] = useState(initalState)

  return {
    formValue,
    addValue: (values) => {
      const newFormValue = {
        ...formValue
      }
      _.each(values, (value, key) => {
        newFormValue[key] = value
      })
      if (!_.isEqual(formValue, newFormValue)) {
        setFormValue(newFormValue)
      }
    },
    removeValue: (values) => {
      const newFormValue = {
        ...formValue
      }
      _.each(values, (key) => {
        delete newFormValue[key]
      })
      if (!_.isEqual(formValue, newFormValue)) {
        setFormValue(newFormValue)
      }
    }
  }
}

export default useForm
